import React from 'react'

const FeedSage = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.3 28.3">
    <path d="M21.3 0H7.1C5.5 0 4.3 1.2 4.2 2.9v14.2c0 1.5 1.3 2.9 2.9 2.9h14.2c1.5 0 2.9-1.3 2.9-2.9V2.9c0-1.6-1.4-2.9-2.9-2.9zM23.5 22.7H5c-.4 0-.7.3-.7.7s.2.6.7.6h18.5c.3 0 .7-.2.7-.7 0-.2-.3-.6-.7-.6zM23.5 27H5c-.4 0-.7.3-.7.7 0 .3.2.7.7.7h18.5c.3 0 .7-.2.7-.7 0-.3-.3-.7-.7-.7z" />
  </svg>
)

export default FeedSage
